<div class="form-builder-container">

  <!-- 階段模式切換開關 -->
  <!-- <div class="form-builder-header">
    <div class="form-mode-selector">
      <label class="mode-toggle">
        <input type="checkbox"
               [(ngModel)]="enableStageMode"
               (ngModelChange)="onStageModeToggle()">
        <span class="toggle-text">
          <i class="fas fa-layer-group"></i>
          啟用多階段填寫模式
        </span>
      </label>
      <small class="help-text" *ngIf="!enableStageMode">
        適用於需要不同部門依序填寫的表單
      </small>
    </div>
  </div> -->

  <!-- 布局 -->
  <div class="form-builder-layout">

    <!-- 階段管理欄（當啟用多階段時顯示，但在簽核步驟模式下隱藏） -->
    <div class="stage-management-panel"
         *ngIf="enableStageMode && !hideAdvancedFeatures"
         [class.collapsed]="isPanelCollapsed('stageManagement')">
      <div class="panel-header">
        <h4><i class="fas fa-layer-group"></i> 階段管理</h4>
        <button class="btn-collapse"
                (click)="togglePanelCollapse('stageManagement')"
                [title]="isPanelCollapsed('stageManagement') ? '展開' : '收合'">
          <i class="fas"
             [class.fa-chevron-left]="!isPanelCollapsed('stageManagement')"
             [class.fa-chevron-right]="isPanelCollapsed('stageManagement')"></i>
        </button>
      </div>

      <div class="panel-footer" *ngIf="!isPanelCollapsed('stageManagement')">
        <button class="btn btn-sm btn-primary" (click)="addNewStage()">
          <i class="fas fa-plus"></i> 新增
        </button>
      </div>

      <div class="stage-management-content" *ngIf="!isPanelCollapsed('stageManagement')">
        <div class="stages-list">
          <div class="stage-item"
               *ngFor="let stage of formStages; let i = index"
               [class.active]="currentEditingStage === stage.id"
               (click)="selectStage(stage.id)">
            <div class="stage-header">
              <div class="stage-number">{{ stage.order || (i + 1) }}</div>
              <div class="stage-name">{{ stage.name }}</div>
              <div class="stage-actions">
                <button class="btn-icon" (click)="editStage(stage); $event.stopPropagation()"
                        [title]="'編輯階段'">
                  <i class="fas fa-edit"></i>
                </button>
                <button class="btn-icon btn-danger" (click)="deleteStage(stage); $event.stopPropagation()"
                        [title]="'刪除階段'">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>
            <div class="stage-description" *ngIf="stage.description">
              {{ stage.description }}
            </div>
            <div class="stage-info">
              <span class="info-item">
                <i class="fas fa-list"></i>
                {{ getStageFieldsCount(stage.id) }} 個元件
              </span>
              <span class="info-item" *ngIf="stage.requiredDepartments?.length">
                <i class="fas fa-users"></i>
                {{ stage.requiredDepartments.length }} 個部門
              </span>
            </div>
          </div>
        </div>

        <!-- 首次啟用時的引導 -->
        <!-- <div class="stage-guide" *ngIf="enableStageMode && isFirstTimeStageUser">
          <div class="guide-card">
            <div class="guide-header">
              <i class="fas fa-lightbulb"></i>
              <h5>多階段填寫模式</h5>
            </div>
            <div class="guide-content">
              <p>您已啟用多階段填寫模式！</p>
              <ul>
                <li>建立不同階段來組織表單</li>
                <li>指定元件所屬的階段</li>
                <li>設定各階段的負責部門</li>
              </ul>
              <button class="btn btn-sm btn-primary" (click)="dismissGuide()">
                我知道了
              </button>
            </div>
          </div>
        </div> -->

        <!-- 批次操作工具 -->
        <!-- <div class="batch-tools" *ngIf="enableStageMode && formStages.length > 0 && !isFirstTimeStageUser">
          <div class="tools-header">
            <h5><i class="fas fa-tools"></i> 批次工具</h5>
          </div>
          <div class="tools-content">
            <button class="btn btn-sm btn-outline-primary" (click)="autoAssignFieldsToStages()"
                    *ngIf="getFormCompletionStats().unassigned > 0">
              <i class="fas fa-magic"></i> 自動分配欄位
            </button>
            <button class="btn btn-sm btn-outline-secondary" (click)="validateAllStages()">
              <i class="fas fa-check-circle"></i> 驗證設定
            </button>
            <div class="stats-info" *ngIf="getFormCompletionStats().total > 0">
              <div class="stat-item">
                <span class="stat-label">已分配元件：</span>
                <span class="stat-value">{{ getFormCompletionStats().assigned }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-label">未分配元件：</span>
                <span class="stat-value text-warning" *ngIf="getFormCompletionStats().unassigned > 0">
                  {{ getFormCompletionStats().unassigned }}
                </span>
                <span class="stat-value" *ngIf="getFormCompletionStats().unassigned === 0">0</span>
              </div>
            </div>
          </div>
        </div> -->
      </div>



    </div>

    <!-- 左側：元件庫 -->
    <div class="component-library"
         [class.with-stage-panel]="enableStageMode"
         [class.collapsed]="isPanelCollapsed('componentLibrary')">
      <div class="panel-header">
        <h4><i class="fas fa-puzzle-piece"></i> {{ 'form.builder.component_library' | translate }}</h4>
        <!-- <button class="btn-collapse"
                (click)="togglePanelCollapse('componentLibrary')"
                [title]="isPanelCollapsed('componentLibrary') ? '展開' : '收合'">
          <i class="fas"
             [class.fa-chevron-left]="!isPanelCollapsed('componentLibrary')"
             [class.fa-chevron-right]="isPanelCollapsed('componentLibrary')"></i>
        </button> -->
      </div>

      <!-- 搜尋框 -->
      <div class="search-container" *ngIf="!isPanelCollapsed('componentLibrary')">
        <div class="search-input-group">
          <input type="text"
                 class="form-control search-input"
                 [(ngModel)]="searchTerm"
                 (input)="onSearchChange()"
                 [placeholder]="'form.builder.search_components' | translate">
          <button class="btn btn-clear"
                  *ngIf="searchTerm"
                  (click)="clearSearch()"
                  [title]="'form.builder.clear_search' | translate">
            <i class="fas fa-times"></i>
          </button>
          <span class="search-icon">
            <i class="fas fa-search"></i>
          </span>
        </div>
      </div>

      <!-- 分類顯示 -->
      <div class="component-categories" *ngIf="!isPanelCollapsed('componentLibrary')">

        <!-- 搜尋模式：顯示搜尋結果 -->
        <div *ngIf="searchTerm.trim()" class="search-results">
          <div class="category-header search-results-header">
            <i class="fas fa-search"></i>
            <span>{{ 'form.builder.search_results' | translate }} ({{ filteredComponents.length }})</span>
          </div>
          <div class="component-list"
               cdkDropList
               [cdkDropListConnectedTo]="['form-construction-area']"
               [cdkDropListSortingDisabled]="true"
               [cdkDropListData]="filteredComponents"
               (cdkDropListDropped)="onDrop($event)">
            <div class="component-item"
                 *ngFor="let component of filteredComponents; let i = index"
                 [class.disabled]="!canAddComponentType(component.type)"
                 [title]="!canAddComponentType(component.type) && component.type === 'approval-flow' ? ('form.builder.cannot_add_approval_flow' | translate) : ''"
                 cdkDrag
                 [cdkDragData]="component"
                 [cdkDragDisabled]="!canAddComponentType(component.type)">
              <div class="component-icon">
                <i [class]="component.icon"></i>
              </div>
              <div class="component-info">
                <div class="component-label">{{ component.label }}</div>
                <div class="component-type">{{ component.type }}</div>
              </div>

              <!-- 拖拉提示 -->
              <div class="drag-placeholder" *cdkDragPlaceholder>
                <div class="placeholder-content">
                  <i [class]="component.icon"></i>
                  <span>{{ component.label }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 正常模式：按分類顯示 -->
        <div *ngIf="!searchTerm.trim()" class="categories-normal">
          <div *ngFor="let category of categories" class="component-category"
               [class.category-collapsed]="!category.expanded">

            <!-- 分類標題 -->
            <div class="category-header" (click)="toggleCategory(category.id)">
              <div class="category-info">
                <i [class]="category.icon"></i>
                <span>{{ category.label }}</span>
                <span class="category-count">({{ getCategoryComponents(category.id).length }})</span>
              </div>
              <i class="fas fa-chevron-down category-toggle"
                 [class.category-toggle-collapsed]="!category.expanded"></i>
            </div>

            <!-- 分類元件列表 -->
            <div class="category-content" [class.category-content-collapsed]="!category.expanded">
              <div class="component-list"
                   cdkDropList
                   [cdkDropListConnectedTo]="['form-construction-area']"
                   [cdkDropListSortingDisabled]="true"
                   [cdkDropListData]="getCategoryComponents(category.id)"
                   (cdkDropListDropped)="onDrop($event)">
                <div class="component-item"
                     *ngFor="let component of getCategoryComponents(category.id); let i = index"
                     [class.disabled]="!canAddComponentType(component.type)"
                     [title]="!canAddComponentType(component.type) && component.type === 'approval-flow' ? ('form.builder.cannot_add_approval_flow' | translate) : ''"
                     cdkDrag
                     [cdkDragData]="component"
                     [cdkDragDisabled]="!canAddComponentType(component.type)">
                  <div class="component-icon">
                    <i [class]="component.icon"></i>
                  </div>
                  <div class="component-info">
                    <div class="component-label">{{ component.label }}</div>
                    <div class="component-type">{{ component.type }}</div>
                  </div>

                  <!-- 拖拉提示 -->
                  <div class="drag-placeholder" *cdkDragPlaceholder>
                    <div class="placeholder-content">
                      <i [class]="component.icon"></i>
                      <span>{{ component.label }}</span>
                    </div>
                  </div>
                </div>

                <!-- 空分類提示 -->
                <div *ngIf="getCategoryComponents(category.id).length === 0 && category.expanded" class="empty-category">
                  <span>{{ 'form.builder.no_components_in_category' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 中間：表單建構區域 -->
    <div class="form-construction" [class.collapsed]="isPanelCollapsed('formConstruction')">
      <div class="panel-header">
        <h4><i class="fas fa-edit"></i> {{ 'form.builder.form_construction_area' | translate }}</h4>
        <div class="construction-actions">
          <button class="btn btn-sm btn-outline-secondary" (click)="clearForm()"
                  [disabled]="formItems.length === 0" [title]="'form.builder.clear_form' | translate">
            <i class="fas fa-trash"></i> {{ 'form.builder.clear_form' | translate }}
          </button>
          <!-- <button class="btn-collapse"
                  (click)="togglePanelCollapse('formConstruction')"
                  [title]="isPanelCollapsed('formConstruction') ? '展開' : '收合'">
            <i class="fas"
               [class.fa-chevron-left]="!isPanelCollapsed('formConstruction')"
               [class.fa-chevron-right]="isPanelCollapsed('formConstruction')"></i>
          </button> -->
        </div>
      </div>

      <!-- 階段指示器 -->
      <div class="stage-indicator" *ngIf="enableStageMode && formStages.length > 0 && !isPanelCollapsed('formConstruction')">
        <div class="current-stage-info">
          <h5>正在編輯：{{ getCurrentStageName() || '所有階段' }}</h5>
          <div class="stage-info-hint" *ngIf="currentEditingStage === null">
            <small><i class="fas fa-info-circle"></i> 元件按階段順序排列顯示</small>
          </div>
          <div class="stage-tabs">
            <button class="stage-tab"
                    [class.active]="currentEditingStage === null"
                    (click)="selectStage(null)">
              全部檢視
            </button>
            <button class="stage-tab"
                    *ngFor="let stage of getSortedStages(); let i = index"
                    [class.active]="currentEditingStage === stage.id"
                    (click)="selectStage(stage.id)">
              {{ stage.order || (i + 1) }}. {{ stage.name }}
            </button>
          </div>
        </div>
      </div>

      <div class="construction-area"
           *ngIf="!isPanelCollapsed('formConstruction')"
           cdkDropList
           id="form-construction-area"
           [cdkDropListData]="formItems"
           (cdkDropListDropped)="onDrop($event)">

        <!-- 空狀態提示 -->
        <div class="empty-state" *ngIf="formItems.length === 0">
          <div class="empty-icon">
            <i class="fas fa-mouse-pointer"></i>
          </div>
          <div class="empty-text">
            <p>{{ 'form.builder.drag_components_hint' | translate }}</p>
          </div>
        </div>

        <!-- 表單元件列表 -->
        <div class="form-item"
             *ngFor="let item of getFilteredFormItems(); let i = index"
             [class.selected]="item.selected"
             [class.different-stage]="enableStageMode && isItemInDifferentStage(item)"
             [class.unassigned-item]="enableStageMode && currentEditingStage === null && item._unassigned"
             cdkDrag
             (click)="selectItem(item)">

          <div class="form-item-header">
            <div class="drag-handle" cdkDragHandle>
              <i class="fas fa-grip-vertical"></i>
            </div>
            <div class="item-info">
              <div class="item-label">{{ item.label }}</div>
              <div class="item-type">{{ item.type }}</div>
              <!-- 新增階段標籤 -->
              <div class="item-stage-tag" *ngIf="enableStageMode && item.stageId">
                <small>{{ getStageName(item.stageId) }}</small>
              </div>
            </div>
            <div class="item-actions">
              <button class="btn-icon"
                      (click)="duplicateItem(item); $event.stopPropagation()"
                      [disabled]="!canAddComponentType(item.type)"
                      [title]="!canAddComponentType(item.type) && item.type === 'approval-flow' ? ('form.builder.cannot_copy_approval_flow' | translate) : ('form.builder.duplicate' | translate)">
                <i class="fas fa-copy"></i>
              </button>
              <button class="btn-icon btn-danger" (click)="deleteItem(item); $event.stopPropagation()"
                      [title]="'form.builder.delete' | translate">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>

          <div class="form-item-preview">
            <div class="preview-label">{{ item.label }}</div>
            <div class="preview-field" [ngSwitch]="item.type">
              <input *ngSwitchCase="'text-input'" type="text" [placeholder]="item.placeholder" disabled>
              <input *ngSwitchCase="'number-input'" type="number" [placeholder]="item.placeholder" disabled>
              <textarea *ngSwitchCase="'textarea'" [placeholder]="item.placeholder" disabled></textarea>
              <input *ngSwitchCase="'date'" type="date" disabled>
              <input *ngSwitchCase="'datetime'" type="datetime-local" disabled>
              <select *ngSwitchCase="'select'" disabled>
                <option>{{ item.placeholder || ('form.builder.please_select' | translate) }}</option>
                <option *ngFor="let option of item.options || []">{{ option.label }}</option>
              </select>
              <div *ngSwitchCase="'radiobutton'" class="preview-radio">
                <label *ngFor="let option of item.options || []" class="radio-option">
                  <input type="radio" [name]="item.name" disabled> {{ option.label }}
                </label>
              </div>
              <div *ngSwitchCase="'multi-checkbox'" class="preview-checkbox">
                <div *ngFor="let option of item.options || []" class="checkbox-option-wrapper">
                  <label class="checkbox-option">
                    <input type="checkbox" disabled> {{ option.label }}
                    <span *ngIf="option.enableTextInput" class="text-input-indicator">
                      <i class="fas fa-keyboard" title="啟用文字輸入"></i>
                    </span>
                  </label>
                  <div *ngIf="option.enableTextInput" class="preview-text-input">
                    <input type="text" [placeholder]="option.textPlaceholder || '請輸入...'" disabled class="small-text-input">
                  </div>
                </div>
              </div>
              <div *ngSwitchCase="'location'" class="preview-location">
                <input type="text" [placeholder]="item.placeholder" disabled>
                <span class="location-icon"><i class="fas fa-map-marker-alt"></i></span>
              </div>
              <div *ngSwitchCase="'photo-upload'" class="preview-upload">
                <div class="upload-area">
                  <i class="fas fa-camera"></i>
                  <span>{{ 'form.builder.upload_photo' | translate }}</span>
                </div>
              </div>
              <div *ngSwitchCase="'avatar-upload'" class="preview-avatar-upload">
                <div class="avatar-upload-area">
                  <i class="fas fa-user-circle"></i>
                  <span>{{ 'form.builder.upload_avatar' | translate }}</span>
                </div>
              </div>
              <div *ngSwitchCase="'signature'" class="preview-signature">
                <div class="signature-area">
                  <i class="fas fa-signature"></i>
                  <span>{{ 'form.builder.signature_area' | translate }}</span>
                </div>
              </div>
              <div *ngSwitchCase="'paragraph'" class="preview-paragraph">
                <div class="paragraph-content" [style.text-align]="getTextAlign(item)">
                  {{ getParagraphContent(item) }}
                </div>
              </div>
              <div *ngSwitchCase="'rich-text-display'" class="preview-rich-text-display">
                <div class="rich-text-preview"
                     [style.font-size]="getRichTextFontSize(item)"
                     [style.color]="getRichTextColor(item)"
                     [style.text-align]="getRichTextTextAlign(item)"
                     [style.line-height]="getRichTextLineHeight(item)"
                     [style.background-color]="getRichTextBackgroundColor(item)"
                     [style.padding]="getRichTextPadding(item)"
                     [style.border-radius]="getRichTextBorderRadius(item)">
                  <div [innerHTML]="getRichTextContent(item)"></div>
                </div>
              </div>
              <div *ngSwitchCase="'timestamp'" class="preview-timestamp">
                <div class="timestamp-display">
                  <i class="fas fa-clock"></i>
                  <span>{{ getTimestampFormat(item) }} - {{ 'form.builder.timestamp_display' | translate }}</span>
                </div>
              </div>
              <div *ngSwitchCase="'department-selector'" class="preview-department">
                <select disabled>
                  <option>{{ item.placeholder || ('form.builder.select_department' | translate) }}</option>
                </select>
                <span class="selector-icon"><i class="fas fa-sitemap"></i></span>
              </div>
              <div *ngSwitchCase="'personnel-selector'" class="preview-personnel">
                <select disabled [attr.multiple]="getMultiSelect(item) ? true : null">
                  <option>{{ item.placeholder || ('form.builder.select_personnel' | translate) }}</option>
                </select>
                <span class="selector-icon"><i class="fas fa-users"></i></span>
              </div>
              <div *ngSwitchCase="'tags'" class="preview-tags">
                <div class="tag-chip-preview">
                  <span class="tag-sample" *ngFor="let tag of item.options?.slice(0, 3)">{{ tag }}</span>
                  <span class="tag-sample" *ngIf="!item.options || item.options.length === 0">{{ 'form.builder.tag_example' | translate }}</span>
                </div>
                <input type="text" [placeholder]="item.placeholder || ('form.builder.select_or_enter_tags' | translate)" disabled>
                <span class="selector-icon"><i class="fas fa-tags"></i></span>
              </div>
              <div *ngSwitchCase="'approval-flow'" class="preview-approval-flow">
                <div class="approval-flow-preview">
                  <i class="fas fa-route"></i>
                  <span>{{ 'form.builder.approval_flow_component' | translate }}</span>
                </div>
                <div class="flow-info" *ngIf="getSelectedFlow(item)">
                  <small>{{ 'form.builder.flow_selected' | translate: {name: getSelectedFlow(item)?.name || ''} }}</small>
                </div>
                <div class="flow-info" *ngIf="!getSelectedFlow(item)">
                  <small>{{ 'form.builder.select_flow_in_properties' | translate }}</small>
                </div>
              </div>
              <div *ngSwitchCase="'dynamic-api-select'" class="preview-dynamic-api-select">
                <select class="form-input" disabled>
                  <option>{{ item.placeholder || '請選擇' }}</option>
                  <option *ngIf="item.apiKey">動態載入選項...</option>
                  <option *ngIf="!item.apiKey">請設定API Key</option>
                </select>
                <div class="api-info">
                  <small *ngIf="item.apiKey" class="text-success">
                    <i class="fas fa-database"></i> API Key: {{ item.apiKey }}
                  </small>
                  <small *ngIf="!item.apiKey" class="text-warning">
                    <i class="fas fa-exclamation-triangle"></i> 請在屬性中設定API Key
                  </small>
                </div>
              </div>
              <div *ngSwitchCase="'dynamic-api-table'" class="preview-dynamic-api-table">
                <div class="table-preview">
                  <div class="table-header">
                    <i class="fas fa-table"></i>
                    <span>動態API表格選擇</span>
                  </div>
                  <div class="table-mock">
                    <div class="table-row">
                      <div class="table-cell">
                        <input type="checkbox" disabled>
                      </div>
                      <div class="table-cell">項目1</div>
                      <div class="table-cell">說明1</div>
                    </div>
                    <div class="table-row">
                      <div class="table-cell">
                        <input type="checkbox" disabled>
                      </div>
                      <div class="table-cell">項目2</div>
                      <div class="table-cell">說明2</div>
                    </div>
                  </div>
                  <div class="api-info">
                    <small *ngIf="item.apiKey" class="text-success">
                      <i class="fas fa-database"></i> API Key: {{ item.apiKey }}
                    </small>
                    <small *ngIf="!item.apiKey" class="text-warning">
                      <i class="fas fa-exclamation-triangle"></i> 請在屬性中設定API Key
                    </small>
                    <small *ngIf="item.maxSelections && item.maxSelections > 0" class="text-info">
                      <i class="fas fa-hashtag"></i> 最大選擇數量: {{ item.maxSelections }}
                    </small>
                  </div>
                </div>
              </div>
              <div *ngSwitchCase="'subform-relation'" class="preview-subform-relation">
                <div class="subform-relation-preview">
                  <div class="relation-info">
                    <i class="fas fa-link"></i>
                    <span>{{ 'form.builder.subform_relation_component' | translate }}</span>
                  </div>
                  <div class="subform-info" *ngIf="item.formId">
                    <small class="text-success">
                      <i class="fas fa-database"></i> {{ 'form.builder.subform_id' | translate }}: {{ item.formId }}
                    </small>
                  </div>
                  <div class="subform-info" *ngIf="!item.formId">
                    <small class="text-warning">
                      <i class="fas fa-exclamation-triangle"></i> {{ 'form.builder.subform_id_not_set' | translate }}
                    </small>
                  </div>
                </div>
              </div>
              <div *ngSwitchCase="'video-player'" class="preview-video-player">
                <div class="video-preview-container">
                  <div class="video-preview-placeholder" *ngIf="!item.youtubeUrl">
                    <i class="fas fa-play"></i>
                    <span>{{ 'form.builder.video_player_placeholder' | translate }}</span>
                    <small>{{ 'form.builder.set_youtube_url_in_properties' | translate }}</small>
                  </div>
                  <div class="video-preview-info" *ngIf="item.youtubeUrl">
                    <i class="fas fa-play"></i>
                    <div class="video-info">
                      <span class="video-title" *ngIf="item.videoTitle">{{ item.videoTitle }}</span>
                      <span class="video-title" *ngIf="!item.videoTitle">{{ 'form.builder.youtube_video' | translate }}</span>
                      <small class="video-url">{{ item.youtubeUrl }}</small>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngSwitchCase="'file-upload-manager'" class="preview-file-upload-manager">
                <div class="file-upload-preview">
                  <div class="upload-area-preview">
                    <i class="fas fa-cloud-upload-alt"></i>
                    <span>{{ 'file_upload.drag_drop_text' | translate }}</span>
                    <small>{{ 'form.builder.file_upload_manager_settings' | translate }}</small>
                  </div>
                  <!-- <div class="upload-config-info">
                    <small>
                      {{ 'form.builder.max_files' | translate }}: {{ (item as any).fileUploadConfig?.maxFiles || 5 }} |
                      {{ 'form.builder.max_size' | translate }}: {{ (item as any).fileUploadConfig?.maxFileSize || 10 }}MB
                    </small>
                  </div> -->
                </div>
              </div>
              <div *ngSwitchCase="'required-document-upload'" class="preview-required-document-upload">
                <div class="required-document-preview">
                  <div class="document-header-preview">
                    <i class="fas fa-certificate"></i>
                    <span class="document-name">{{ getRequiredDocumentName(item) }}</span>
                    <span class="required-indicator" *ngIf="item.required">*</span>
                  </div>
                  <div class="upload-area-preview">
                    <i class="fas fa-cloud-upload-alt"></i>
                    <span>{{ 'required_document.click_or_drag_upload' | translate }} {{ getRequiredDocumentName(item) }}</span>
                    <small *ngIf="isRequiredDocumentAiParsingEnabled(item)" class="ai-parsing-indicator">
                      <i class="fas fa-robot"></i> {{ 'required_document.ai_parsing_enabled' | translate }}
                    </small>
                  </div>
                </div>
              </div>
              <div *ngSwitchCase="'audio-recorder'" class="preview-audio-recorder">
                <div class="audio-recorder-preview">
                  <div class="recorder-controls">
                    <button type="button" class="btn-preview recording-btn" disabled>
                      <i class="fas fa-microphone"></i>
                      <span>{{ 'form.audio_recorder.start_recording' | translate }}</span>
                    </button>
                  </div>
                  <div class="recorder-info">
                    <small>{{ 'form.builder.max_recording_duration' | translate:{ duration: getMaxDuration(item) } }} | {{ 'form.builder.audio_quality' | translate:{ quality: getAudioQuality(item) } }}</small>
                  </div>
                </div>
              </div>
              <div *ngSwitchCase="'fill-in'" class="preview-fill-in">
                <div class="fill-in-preview-container">
                  <div class="template-preview" *ngIf="item.template">
                    <span class="template-text">{{ item.template }}</span>
                  </div>
                  <div class="template-preview" *ngIf="!item.template">
                    <span class="template-placeholder">請設定模板內容...</span>
                  </div>
                  <div class="fields-info" *ngIf="getFillInFields(item).length > 0">
                    <small>填空格數量: {{ getFillInFields(item).length }}</small>
                  </div>
                </div>
              </div>
              <div *ngSwitchCase="'meeting-signature-collection'" class="preview-meeting-signature-collection">
                <div class="meeting-signature-preview">
                  <div class="signature-header">
                    <i class="fas fa-users"></i>
                    <span>{{ 'form.builder.meeting_signature_collection' | translate }}</span>
                  </div>
                  <div class="signature-info" *ngIf="item.title">
                    <small class="text-success">
                      <i class="fas fa-heading"></i> {{ 'form.builder.signature_title' | translate }}: {{ item.title }}
                    </small>
                  </div>
                  <div class="signature-info" *ngIf="item.participants && item.participants.length > 0">
                    <small class="text-info">
                      <i class="fas fa-user-friends"></i> {{ 'form.builder.participants_count' | translate }}: {{ item.participants.length }}
                    </small>
                  </div>
                  <div class="signature-info" *ngIf="!item.title">
                    <small class="text-warning">
                      <i class="fas fa-exclamation-triangle"></i> {{ 'form.builder.signature_title_not_set' | translate }}
                    </small>
                  </div>
                </div>
              </div>
              <div *ngSwitchCase="'file-display'" class="preview-file-display">
                <div class="file-display-preview">
                  <div class="file-header">
                    <i class="fas fa-file-alt"></i>
                    <span>{{ 'form.builder.file_display_component' | translate }}</span>
                  </div>
                  <div class="file-info" *ngIf="item.files && item.files.length > 0">
                    <small class="text-success">
                      <i class="fas fa-folder"></i> {{ 'form.builder.files_count' | translate }}: {{ item.files.length }}
                    </small>
                  </div>
                  <div class="file-info" *ngIf="!item.files || item.files.length === 0">
                    <small class="text-warning">
                      <i class="fas fa-exclamation-triangle"></i> {{ 'form.builder.no_files_configured' | translate }}
                    </small>
                  </div>
                </div>
              </div>
              <div *ngSwitchCase="'auto-numbering'" class="preview-auto-numbering">
                <div class="auto-numbering-preview">
                  <div class="numbering-display">
                    <i class="fas fa-list-ol"></i>
                    <span>{{ generateAutoNumberingPreview(item) }}</span>
                  </div>
                  <div class="numbering-info">
                    <small class="text-muted">
                      <i class="fas fa-sync-alt"></i> {{ 'form.autoNumbering.auto_generated' | translate }}
                    </small>
                  </div>
                </div>
              </div>
              <div *ngSwitchDefault class="preview-unknown">
                <span>{{ 'form.builder.unknown_component' | translate: {type: item.type} }}</span>
              </div>
            </div>
          </div>

          <!-- 拖拉預覽 -->
          <div class="drag-placeholder" *cdkDragPlaceholder>
            <div class="placeholder-content">
              <i class="fas fa-grip-vertical"></i>
              <span>{{ item.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>



    <!-- 右側：屬性面板 -->
    <div class="properties-panel" [class.collapsed]="isPanelCollapsed('properties')">
      <div class="panel-header">
        <h4><i class="fas fa-cogs"></i> {{ 'form.builder.properties_panel' | translate }}</h4>
        <!-- <button class="btn-collapse"
                (click)="togglePanelCollapse('properties')"
                [title]="isPanelCollapsed('properties') ? '展開' : '收合'">
          <i class="fas"
             [class.fa-chevron-right]="!isPanelCollapsed('properties')"
             [class.fa-chevron-left]="isPanelCollapsed('properties')"></i>
        </button> -->
      </div>

      <div class="properties-content" *ngIf="selectedItem && !isPanelCollapsed('properties'); else noSelection">
        <!-- 隱藏元件類型欄位 -->
        <!-- <div class="property-group">
          <label>{{ 'form.builder.component_type' | translate }}</label>
          <div class="property-value readonly">{{ selectedItem.type }}</div>
        </div> -->

        <div class="property-group">
          <label for="item-label">{{ 'form.builder.label_text' | translate }}</label>
          <input type="text"
                 id="item-label"
                 class="form-control"
                 [(ngModel)]="selectedItem.label"
                 (ngModelChange)="updateSelectedItem()"
                 [placeholder]="'form.builder.enter_label_text' | translate">
        </div>

        <!-- 階段歸屬設定 -->
        <div class="property-group" *ngIf="selectedItem && enableStageMode">
          <label for="item-stage">歸屬階段</label>
          <select id="item-stage"
                  class="form-control"
                  [(ngModel)]="selectedItem.stageId"
                  (ngModelChange)="updateSelectedItem()">
            <option value="">不指定階段（全部可見）</option>
            <option *ngFor="let stage of formStages" [value]="stage.id">
              階段 {{ getStageOrder(stage) }}: {{ stage.name }}
            </option>
          </select>
        </div>

        <!-- 隱藏欄位名稱欄位 -->
        <!-- <div class="property-group">
          <label for="item-name">{{ 'form.builder.field_name' | translate }}</label>
          <input type="text"
                 id="item-name"
                 class="form-control"
                 [(ngModel)]="selectedItem.name"
                 (ngModelChange)="updateSelectedItem()"
                 [placeholder]="'form.builder.enter_field_name' | translate">
        </div> -->

        <div class="property-group" *ngIf="selectedItem.type !== 'photo-upload' && selectedItem.type !== 'signature' && selectedItem.type !== 'paragraph' && selectedItem.type !== 'timestamp'">
          <label for="item-placeholder">{{ 'form.builder.placeholder_text' | translate }}</label>
          <input type="text"
                 id="item-placeholder"
                 class="form-control"
                 [(ngModel)]="selectedItem.placeholder"
                 (ngModelChange)="updateSelectedItem()"
                 [placeholder]="'form.builder.enter_placeholder_text' | translate">
        </div>

        <!-- 段落元件特殊屬性 -->
        <div class="property-group" *ngIf="selectedItem.type === 'paragraph'">
          <label for="paragraph-content">{{ 'form.builder.paragraph_content' | translate }}</label>
          <textarea
                 id="paragraph-content"
                 class="form-control"
                 [ngModel]="getParagraphContent(selectedItem)"
                 (ngModelChange)="setParagraphContent($event); updateSelectedItem()"
                 [placeholder]="'form.builder.enter_paragraph_content' | translate"
                 rows="4"></textarea>
        </div>

        <div class="property-group" *ngIf="selectedItem.type === 'paragraph'">
          <label for="text-align">{{ 'form.builder.text_align' | translate }}</label>
          <select
                 id="text-align"
                 class="form-control"
                 [ngModel]="getTextAlign(selectedItem)"
                 (ngModelChange)="setTextAlign($event); updateSelectedItem()">
            <option value="left">{{ 'form.builder.left_align' | translate }}</option>
            <option value="center">{{ 'form.builder.center_align' | translate }}</option>
            <option value="right">{{ 'form.builder.right_align' | translate }}</option>
          </select>
        </div>

        <!-- 富文本顯示元件特殊屬性 -->
        <div class="property-group" *ngIf="selectedItem.type === 'rich-text-display'">
          <label for="rich-text-content">富文本內容</label>
          <textarea
                 id="rich-text-content"
                 class="form-control"
                 [ngModel]="getRichTextContent(selectedItem)"
                 (ngModelChange)="setRichTextContent($event); updateSelectedItem()"
                 placeholder="請輸入 HTML 內容，支援 &lt;p&gt;, &lt;strong&gt;, &lt;em&gt;, &lt;a&gt;, &lt;img&gt; 等標籤"
                 rows="6"></textarea>
          <small class="help-text">支援 HTML 標籤：&lt;p&gt;, &lt;strong&gt;, &lt;em&gt;, &lt;u&gt;, &lt;br&gt;, &lt;a&gt;, &lt;img&gt; 等</small>
        </div>

        <!-- <div class="property-group" *ngIf="selectedItem.type === 'rich-text-display'">
          <label for="rich-text-font-size">字型大小</label>
          <select
                 id="rich-text-font-size"
                 class="form-control"
                 [ngModel]="getRichTextFontSize(selectedItem)"
                 (ngModelChange)="setRichTextFontSize($event); updateSelectedItem()">
            <option value="12px">12px</option>
            <option value="14px">14px</option>
            <option value="16px">16px</option>
            <option value="18px">18px</option>
            <option value="20px">20px</option>
            <option value="24px">24px</option>
          </select>
        </div>

        <div class="property-group" *ngIf="selectedItem.type === 'rich-text-display'">
          <label for="rich-text-color">文字顏色</label>
          <input type="color"
                 id="rich-text-color"
                 class="form-control"
                 [ngModel]="getRichTextColor(selectedItem)"
                 (ngModelChange)="setRichTextColor($event); updateSelectedItem()">
        </div> -->

        <div class="property-group" *ngIf="selectedItem.type === 'rich-text-display'">
          <label for="rich-text-align">文字對齊</label>
          <select
                 id="rich-text-align"
                 class="form-control"
                 [ngModel]="getRichTextTextAlign(selectedItem)"
                 (ngModelChange)="setRichTextTextAlign($event); updateSelectedItem()">
            <option value="left">{{ 'form.builder.left_align' | translate }}</option>
            <option value="center">{{ 'form.builder.center_align' | translate }}</option>
            <option value="right">{{ 'form.builder.right_align' | translate }}</option>
            <option value="justify">兩端對齊</option>
          </select>
        </div>
<!--
        <div class="property-group" *ngIf="selectedItem.type === 'rich-text-display'">
          <label for="rich-text-line-height">行間距</label>
          <select
                 id="rich-text-line-height"
                 class="form-control"
                 [ngModel]="getRichTextLineHeight(selectedItem)"
                 (ngModelChange)="setRichTextLineHeight($event); updateSelectedItem()">
            <option value="1.2">1.2</option>
            <option value="1.5">1.5</option>
            <option value="1.8">1.8</option>
            <option value="2.0">2.0</option>
          </select>
        </div>

        <div class="property-group" *ngIf="selectedItem.type === 'rich-text-display'">
          <label for="rich-text-bg-color">背景顏色</label>
          <input type="color"
                 id="rich-text-bg-color"
                 class="form-control"
                 [ngModel]="getRichTextBackgroundColor(selectedItem)"
                 (ngModelChange)="setRichTextBackgroundColor($event); updateSelectedItem()">
          <small class="help-text">留空表示透明背景</small>
        </div>

        <div class="property-group" *ngIf="selectedItem.type === 'rich-text-display'">
          <label for="rich-text-padding">內邊距</label>
          <input type="text"
                 id="rich-text-padding"
                 class="form-control"
                 [ngModel]="getRichTextPadding(selectedItem)"
                 (ngModelChange)="setRichTextPadding($event); updateSelectedItem()"
                 placeholder="例如：10px 或 10px 20px">
        </div>

        <div class="property-group" *ngIf="selectedItem.type === 'rich-text-display'">
          <label for="rich-text-border-radius">圓角設定</label>
          <input type="text"
                 id="rich-text-border-radius"
                 class="form-control"
                 [ngModel]="getRichTextBorderRadius(selectedItem)"
                 (ngModelChange)="setRichTextBorderRadius($event); updateSelectedItem()"
                 placeholder="例如：5px">
        </div> -->

        <!-- 時間戳記元件特殊屬性 -->
        <div class="property-group" *ngIf="selectedItem.type === 'timestamp'">
          <label for="timestamp-format">{{ 'form.builder.timestamp_format' | translate }}</label>
          <select
                 id="timestamp-format"
                 class="form-control"
                 [ngModel]="getTimestampFormat(selectedItem)"
                 (ngModelChange)="setTimestampFormat($event); updateSelectedItem()">
            <option value="date">{{ 'form.builder.date_only' | translate }}</option>
            <option value="time">{{ 'form.builder.time_only' | translate }}</option>
            <option value="datetime">{{ 'form.builder.datetime' | translate }}</option>
          </select>
        </div>

        <!-- 填空元件特殊屬性 -->
        <div class="property-group" *ngIf="selectedItem.type === 'fill-in'">
          <label for="fill-in-template">模板內容</label>
          <textarea
                 id="fill-in-template"
                 class="form-control"
                 [(ngModel)]="selectedItem.template"
                 (ngModelChange)="updateSelectedItem()"
                 placeholder="例如：危險物報告 [weight] 公斤處理方式（[method]）"
                 rows="3"></textarea>
          <small class="text-muted">使用 [欄位ID] 來標記填空格位置</small>
        </div>

        <div class="property-group" *ngIf="selectedItem.type === 'fill-in'">
          <label>填空格設定</label>
          <div class="fields-config">
            <div *ngFor="let field of getFillInFields(selectedItem); let i = index" class="field-item">
              <div class="field-row">
                <div class="field-input">
                  <label>欄位ID</label>
                  <input type="text"
                         class="form-control"
                         [(ngModel)]="field.id"
                         (ngModelChange)="updateSelectedItem()"
                         placeholder="欄位ID">
                </div>
                <div class="field-input">
                  <label>類型</label>
                  <select class="form-control"
                          [(ngModel)]="field.type"
                          (ngModelChange)="updateSelectedItem()">
                    <option value="text">文字</option>
                    <option value="number">數字</option>
                    <option value="date">日期</option>
                  </select>
                </div>
                <div class="field-input">
                  <label>寬度</label>
                  <select class="form-control"
                          [(ngModel)]="field.width"
                          (ngModelChange)="updateSelectedItem()">
                    <option value="xs">極小</option>
                    <option value="sm">小</option>
                    <option value="md">中</option>
                    <option value="lg">大</option>
                  </select>
                </div>
                <div class="field-input">
                  <label>提示文字</label>
                  <input type="text"
                         class="form-control"
                         [(ngModel)]="field.placeholder"
                         (ngModelChange)="updateSelectedItem()"
                         placeholder="提示文字">
                </div>
                <button type="button"
                        class="btn btn-sm btn-danger remove-field-btn"
                        (click)="removeFillInField(i)">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>

            <button type="button"
                    class="btn btn-sm btn-primary add-field-btn"
                    (click)="addFillInField()">
              <i class="fas fa-plus"></i> 新增填空格
            </button>
          </div>
        </div>

        <!-- 部門選擇器和人員選擇器的提示文字 -->
        <div class="property-group" *ngIf="selectedItem.type === 'department-selector' || selectedItem.type === 'personnel-selector'">
          <label for="item-placeholder">{{ 'form.builder.placeholder_text' | translate }}</label>
          <input type="text"
                 id="item-placeholder"
                 class="form-control"
                 [(ngModel)]="selectedItem.placeholder"
                 (ngModelChange)="updateSelectedItem()"
                 [placeholder]="'form.builder.enter_placeholder_text' | translate">
        </div>

        <!-- 題目圖片上傳區域（針對單選按鈕） -->
        <div class="property-group" *ngIf="selectedItem.type === 'radiobutton'">
          <label class="upload-label">題目圖片</label>

          <!-- 圖片預覽 -->
          <div class="image-preview-container" *ngIf="getQuestionImageUrl()">
            <img [src]="getQuestionImageUrl()"
                 [alt]="getQuestionImageAltText() || '題目圖片預覽'"
                 class="question-image-preview">
            <button type="button" class="btn-icon btn-danger remove-image-btn"
                    (click)="removeQuestionImage()"
                    title="刪除圖片">
              <i class="fas fa-trash"></i>
            </button>
          </div>

          <!-- 上傳按鈕 -->
          <input type="file" class="file-input"
                 #questionImageInput
                 accept="image/*"
                 (change)="onQuestionImageUpload($event)"
                 style="display: none;">
          <button type="button" class="btn btn-sm btn-outline-primary upload-btn"
                  (click)="questionImageInput.click()"
                  *ngIf="!getQuestionImageUrl()">
            <i class="fas fa-upload"></i> 上傳題目圖片
          </button>

          <!-- 替代文字輸入 -->
          <div class="alt-text-section" *ngIf="getQuestionImageUrl()">
            <label for="question-image-alt">圖片替代文字</label>
            <input type="text" id="question-image-alt" class="form-control"
                   [ngModel]="getQuestionImageAltText()"
                   (ngModelChange)="setQuestionImageAltText($event); updateSelectedItem()"
                   placeholder="請輸入圖片說明（無障礙）">
            <small class="help-text">用於螢幕閱讀器，簡述圖片內容</small>
          </div>
        </div>

        <!-- 人員選擇器特殊屬性 -->
        <div class="property-group" *ngIf="selectedItem.type === 'personnel-selector'">
          <label>
            <input type="checkbox"
                   [ngModel]="getMultiSelect(selectedItem)"
                   (ngModelChange)="setMultiSelect($event); updateSelectedItem()">
            {{ 'form.builder.multi_select_mode' | translate }}
          </label>
        </div>

        <!-- 選項設定（針對 select、radio、checkbox、tags） -->
        <div class="property-group" *ngIf="['select', 'radiobutton', 'multi-checkbox', 'tags'].includes(selectedItem.type)">
          <label>{{ selectedItem.type === 'tags' ? ('form.builder.default_tags' | translate) : ('form.builder.options_setting' | translate) }}</label>
          <div class="options-list">
            <!-- Tags 元件的簡化選項設定 -->
            <ng-container *ngIf="selectedItem.type === 'tags'">
              <div class="option-item" *ngFor="let option of selectedItem.options; let i = index">
                <input type="text"
                       class="form-control tag-option"
                       [ngModel]="getOptionValue(i)"
                       (input)="onOptionValueInput(i, $event)"
                       (blur)="onOptionValueBlur(i, $event)"
                       [placeholder]="'form.builder.tag_name' | translate">
                <button class="btn-icon btn-danger" (click)="removeOption(i)" [title]="'form.builder.delete' | translate">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </ng-container>

            <!-- 其他元件的原有選項設定 -->
            <ng-container *ngIf="selectedItem.type !== 'tags'">
              <div class="option-item" *ngFor="let option of selectedItem.options; let i = index" [attr.data-debug]="'option-' + i + '-' + option?.label">
                <input type="text"
                       class="form-control option-name"
                       [ngModel]="getOptionName(i)"
                       (input)="onOptionNameInput(i, $event)"
                       (blur)="onOptionNameBlur(i, $event)"
                       [placeholder]="'form.builder.option_name' | translate">
                <!-- <input type="text"
                       class="form-control option-value"
                       [ngModel]="getOptionValueField(i)"
                       (input)="onOptionValueFieldInput(i, $event)"
                       (blur)="onOptionValueFieldBlur(i, $event)"
                       [placeholder]="'form.builder.option_value' | translate"> -->
                <button class="btn-icon btn-danger" (click)="removeOption(i)" [title]="'form.builder.delete' | translate">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </ng-container>
          </div>
          <button class="btn btn-sm btn-outline-primary add-option-btn" (click)="addOption()">
            <i class="fas fa-plus"></i> {{ selectedItem.type === 'tags' ? ('form.builder.add_tag' | translate) : ('form.builder.add_option' | translate) }}
          </button>
        </div>

        <!-- 多選核取方塊條件式文字輸入設定 -->
        <div class="property-group" *ngIf="selectedItem.type === 'multi-checkbox'">
          <label>條件式文字輸入設定</label>
          <p class="help-text">為選項設定文字輸入功能，當使用者選擇該選項時可輸入額外資訊</p>

          <div class="checkbox-text-config-list">
            <div class="option-config-item" *ngFor="let option of selectedItem.options; let i = index">
              <div class="option-header">
                <strong>{{ option.label || '選項 ' + (i + 1) }}</strong>
              </div>

              <div class="option-config-controls">
                <div class="checkbox-item">
                  <input type="checkbox"
                         [id]="'enable-text-input-' + i"
                         [ngModel]="getOptionEnableTextInput(i)"
                         (ngModelChange)="setOptionEnableTextInput(i, $event)">
                  <label [for]="'enable-text-input-' + i">啟用文字輸入</label>
                </div>

                <div *ngIf="getOptionEnableTextInput(i)" class="text-input-settings">
                  <div class="input-item">
                    <label>提示文字</label>
                    <input type="text"
                           class="form-control"
                           [ngModel]="getOptionTextPlaceholder(i)"
                           (ngModelChange)="setOptionTextPlaceholder(i, $event)"
                           placeholder="請輸入...">
                  </div>

                  <div class="checkbox-item">
                    <input type="checkbox"
                           [id]="'text-required-' + i"
                           [ngModel]="getOptionTextRequired(i)"
                           (ngModelChange)="setOptionTextRequired(i, $event)">
                    <label [for]="'text-required-' + i">文字輸入為必填</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Radiobutton 條件式輸入設定 -->
        <div class="property-group" *ngIf="selectedItem.type === 'radiobutton'">
          <label>{{ 'form.builder.conditional_inputs' | translate }}</label>
          <p class="help-text">{{ 'form.builder.conditional_inputs_desc' | translate }}</p>

          <!-- 觸發值設定 -->
          <div class="conditional-config-section">
            <h5>{{ 'form.builder.trigger_values' | translate }}</h5>
            <p class="small-help">{{ 'form.builder.trigger_values_desc' | translate }}</p>

            <div class="trigger-values-list">
              <div class="trigger-value-item" *ngFor="let triggerValue of getConditionalTriggerValues(); let i = index">
                <select class="form-control"
                        [ngModel]="triggerValue"
                        (ngModelChange)="updateConditionalTriggerValue(i, $event)">
                  <option value="">{{ 'form.builder.select_option' | translate }}</option>
                  <option *ngFor="let option of selectedItem.options" [value]="option.value || option.label">
                    {{ option.label || option.value }}
                  </option>
                </select>
                <button class="btn-icon btn-danger" (click)="removeConditionalTriggerValue(i)" [title]="'form.builder.delete' | translate">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>

            <button class="btn btn-sm btn-outline-primary" (click)="addConditionalTriggerValue()">
              <i class="fas fa-plus"></i> {{ 'form.builder.add_trigger_value' | translate }}
            </button>
          </div>

          <!-- 功能啟用設定 -->
          <div class="conditional-config-section">
            <h5>{{ 'form.builder.enable_features' | translate }}</h5>

            <div class="checkbox-item">
              <input type="checkbox"
                     id="enable-remarks"
                     [ngModel]="getConditionalEnableRemarks()"
                     (ngModelChange)="setConditionalEnableRemarks($event)">
              <label for="enable-remarks">{{ 'form.builder.enable_remarks' | translate }}</label>
            </div>

            <div class="checkbox-item">
              <input type="checkbox"
                     id="enable-file-upload"
                     [ngModel]="getConditionalEnableFileUpload()"
                     (ngModelChange)="setConditionalEnableFileUpload($event)">
              <label for="enable-file-upload">{{ 'form.builder.enable_file_upload' | translate }}</label>
            </div>

            <div class="checkbox-item">
              <input type="checkbox"
                     id="enable-audio-recorder"
                     [ngModel]="getConditionalEnableAudioRecorder()"
                     (ngModelChange)="setConditionalEnableAudioRecorder($event)">
              <label for="enable-audio-recorder">{{ 'form.builder.enable_audio_recorder' | translate }}</label>
            </div>
          </div>

          <!-- 標籤文字設定 -->
          <div class="conditional-config-section" *ngIf="getConditionalEnableRemarks() || getConditionalEnableFileUpload() || getConditionalEnableAudioRecorder()">
            <h5>{{ 'form.builder.label_settings' | translate }}</h5>

            <div class="input-item" *ngIf="getConditionalEnableRemarks()">
              <label>{{ 'form.builder.remarks_label' | translate }}</label>
              <input type="text"
                     class="form-control"
                     [ngModel]="getConditionalRemarksLabel()"
                     (ngModelChange)="setConditionalRemarksLabel($event)"
                     [placeholder]="'form.builder.remarks_label_placeholder' | translate">
            </div>

            <div class="input-item" *ngIf="getConditionalEnableFileUpload()">
              <label>{{ 'form.builder.file_upload_label' | translate }}</label>
              <input type="text"
                     class="form-control"
                     [ngModel]="getConditionalFileUploadLabel()"
                     (ngModelChange)="setConditionalFileUploadLabel($event)"
                     [placeholder]="'form.builder.file_upload_label_placeholder' | translate">
            </div>

            <div class="input-item" *ngIf="getConditionalEnableAudioRecorder()">
              <label>{{ 'form.builder.audio_recorder_label' | translate }}</label>
              <input type="text"
                     class="form-control"
                     [ngModel]="getConditionalAudioRecorderLabel()"
                     (ngModelChange)="setConditionalAudioRecorderLabel($event)"
                     [placeholder]="'form.builder.audio_recorder_label_placeholder' | translate">
            </div>
          </div>
        </div>

        <!-- 簽核流程特殊屬性 -->
        <div class="property-group" *ngIf="selectedItem.type === 'approval-flow'">
          <label for="approval-flow-select">{{ 'form.builder.select_approval_flow' | translate }}</label>
          <select
                 id="approval-flow-select"
                 class="form-control"
                 [ngModel]="getSelectedApprovalFlowId(selectedItem)"
                 (ngModelChange)="setApprovalFlow($event)">
            <option value="">{{ 'form.builder.please_select_approval_flow' | translate }}</option>
            <option *ngFor="let flow of availableApprovalFlows" [value]="flow.id">
              {{ flow.name }}
            </option>
          </select>

          <!-- 顯示選中流程的詳細資訊 -->
          <div class="flow-detail-preview" *ngIf="getSelectedApprovalFlow(selectedItem)">



            <div class="flow-info-card">
              <div class="flow-header">
                <i class="fas fa-check-circle"></i>
                <span>{{ getSelectedApprovalFlow(selectedItem)?.name }}</span>
              </div>
              <div class="flow-description" *ngIf="getSelectedApprovalFlow(selectedItem)?.description">
                {{ getSelectedApprovalFlow(selectedItem)?.description }}
              </div>
              <div class="flow-steps" *ngIf="getSelectedApprovalFlow(selectedItem)?.steps?.length">
                <small>{{ 'form.builder.approval_steps_count' | translate: {count: getSelectedApprovalFlow(selectedItem)?.steps?.length || 0} }}</small>
              </div>
            </div>
          </div>
        </div>

        <!-- 動態API下拉選單特殊屬性 -->
        <div class="property-group" *ngIf="selectedItem.type === 'dynamic-api-select'">
          <label for="api-key">API Key</label>
          <input type="text"
                 id="api-key"
                 class="form-control"
                 [(ngModel)]="selectedItem.apiKey"
                 (ngModelChange)="updateSelectedItem()"
                 placeholder="請輸入API Key">
          <small class="help-text">設定用於呼叫動態資料API的key值</small>
        </div>

        <!-- 動態API表格選擇特殊屬性 -->
        <div class="property-group" *ngIf="selectedItem.type === 'dynamic-api-table'">
          <label for="api-key-table">API Key</label>
          <input type="text"
                 id="api-key-table"
                 class="form-control"
                 [(ngModel)]="selectedItem.apiKey"
                 (ngModelChange)="updateSelectedItem()"
                 placeholder="請輸入API Key">
          <small class="help-text">設定用於呼叫動態資料API的key值</small>
        </div>

        <div class="property-group" *ngIf="selectedItem.type === 'dynamic-api-table'">
          <label for="max-selections">最大選擇數量</label>
          <input type="number"
                 id="max-selections"
                 class="form-control"
                 [(ngModel)]="selectedItem.maxSelections"
                 (ngModelChange)="updateSelectedItem()"
                 min="0"
                 placeholder="0 (無限制)">
          <small class="help-text">設定最大可選擇的項目數量，0表示無限制</small>
        </div>

        <!-- 子表單關聯特殊屬性 -->
        <div class="property-group" *ngIf="selectedItem.type === 'subform-relation'">
          <label for="form-id">{{ 'form.builder.subform_id' | translate }}</label>
          <input type="text"
                 id="form-id"
                 class="form-control"
                 [(ngModel)]="selectedItem.formId"
                 (ngModelChange)="updateSelectedItem()"
                 [placeholder]="'form.builder.subform_id_placeholder' | translate">
          <small class="help-text">{{ 'form.builder.subform_id_help' | translate }}</small>
        </div>

        <!-- 自動編號特殊屬性 -->
        <div class="auto-numbering-properties" *ngIf="selectedItem.type === 'auto-numbering'">
          <h5>{{ 'form.autoNumbering.config.formatDesigner' | translate }}</h5>

          <!-- 分隔符設定 -->
          <div class="property-group">
            <label for="numbering-separator">{{ 'form.autoNumbering.config.separator' | translate }}</label>
            <input type="text"
                   id="numbering-separator"
                   class="form-control"
                   [ngModel]="getAutoNumberingSeparator(selectedItem)"
                   (ngModelChange)="setAutoNumberingSeparator(selectedItem, $event)"
                   placeholder="-">
            <small class="help-text">元素之間的分隔符號，如：- 或 _</small>
          </div>

          <!-- 編號元素列表 -->
          <div class="property-group">
            <label>{{ 'form.autoNumbering.config.addElement' | translate }}</label>
            <div class="elements-list">
              <div class="element-item" *ngFor="let element of getAutoNumberingElements(selectedItem); let i = index">
                <div class="element-header">
                  <select class="form-control element-type"
                          [(ngModel)]="element.type"
                          (ngModelChange)="updateAutoNumberingElement(selectedItem, i, 'type', $event)">
                    <option value="text">{{ 'form.autoNumbering.elements.text' | translate }}</option>
                    <option value="dropdown">{{ 'form.autoNumbering.elements.dropdown' | translate }}</option>
                    <option value="year">{{ 'form.autoNumbering.elements.year' | translate }}</option>
                    <option value="month">{{ 'form.autoNumbering.elements.month' | translate }}</option>
                    <option value="sequence">{{ 'form.autoNumbering.elements.sequence' | translate }}</option>
                  </select>
                  <div class="element-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary"
                            (click)="moveAutoNumberingElement(selectedItem, i, 'up')"
                            [disabled]="i === 0">
                      <i class="fas fa-arrow-up"></i>
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-secondary"
                            (click)="moveAutoNumberingElement(selectedItem, i, 'down')"
                            [disabled]="i === getAutoNumberingElements(selectedItem).length - 1">
                      <i class="fas fa-arrow-down"></i>
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-danger"
                            (click)="removeAutoNumberingElement(selectedItem, i)">
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </div>

                <!-- 固定文字配置 -->
                <div class="element-config" *ngIf="element.type === 'text'">
                  <input type="text"
                         class="form-control"
                         [(ngModel)]="element.config.text"
                         (ngModelChange)="updateAutoNumberingElementConfig(selectedItem, i)"
                         placeholder="輸入固定文字">
                </div>

                <!-- 下拉選單配置 -->
                <div class="element-config" *ngIf="element.type === 'dropdown'">
                  <!-- 下拉選單標籤設定 -->
                  <div class="input-group mb-3">
                    <label class="form-label">{{ 'form.autoNumbering.config.dropdownLabel' | translate }}</label>
                    <input type="text"
                           class="form-control"
                           [(ngModel)]="element.config.label"
                           (ngModelChange)="updateAutoNumberingElementConfig(selectedItem, i)"
                           placeholder="例如：部門、類別、區域等">
                  </div>

                  <!-- 佔位符設定 -->
                  <div class="input-group mb-3">
                    <label class="form-label">{{ 'form.autoNumbering.config.dropdownPlaceholder' | translate }}</label>
                    <input type="text"
                           class="form-control"
                           [(ngModel)]="element.config.placeholder"
                           (ngModelChange)="updateAutoNumberingElementConfig(selectedItem, i)"
                           placeholder="例如：請選擇部門">
                  </div>

                  <!-- 選項設定 -->
                  <div class="dropdown-options">
                    <label class="form-label">{{ 'form.autoNumbering.config.optionsSettings' | translate }}</label>
                    <div class="option-item" *ngFor="let option of element.config.options; let j = index">
                      <input type="text"
                             class="form-control option-label"
                             [(ngModel)]="option.label"
                             (ngModelChange)="updateAutoNumberingElementConfig(selectedItem, i)"
                             placeholder="選項標籤">
                      <!-- <input type="text"
                             class="form-control option-value"
                             [(ngModel)]="option.value"
                             (ngModelChange)="updateAutoNumberingElementConfig(selectedItem, i)"
                             placeholder="選項值"> -->
                      <button type="button" class="btn btn-sm btn-outline-danger"
                              (click)="removeDropdownOption(selectedItem, i, j)">
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                    <button type="button" class="btn btn-sm btn-outline-primary"
                            (click)="addDropdownOption(selectedItem, i)">
                      <i class="fas fa-plus"></i> 新增選項
                    </button>
                  </div>
                </div>

                <!-- 年份配置 -->
                <div class="element-config" *ngIf="element.type === 'year'">
                  <select class="form-control"
                          [(ngModel)]="element.config.format"
                          (ngModelChange)="updateAutoNumberingElementConfig(selectedItem, i)">
                    <option value="YYYY">完整年份 (2024)</option>
                    <option value="YY">短年份 (24)</option>
                  </select>
                </div>

                <!-- 月份配置 -->
                <div class="element-config" *ngIf="element.type === 'month'">
                  <select class="form-control"
                          [(ngModel)]="element.config.format"
                          (ngModelChange)="updateAutoNumberingElementConfig(selectedItem, i)">
                    <option value="MM">補零月份 (01-12)</option>
                    <option value="M">一般月份 (1-12)</option>
                  </select>
                </div>

                <!-- 流水編號配置 -->
                <div class="element-config" *ngIf="element.type === 'sequence'">
                  <div class="sequence-config">
                    <div class="input-group">
                      <label>{{ 'form.autoNumbering.config.digits' | translate }}</label>
                      <input type="number"
                             class="form-control"
                             [(ngModel)]="element.config.digits"
                             (ngModelChange)="updateAutoNumberingElementConfig(selectedItem, i)"
                             min="1" max="10" placeholder="3">
                    </div>
                    <div class="input-group">
                      <label>{{ 'form.autoNumbering.config.startFrom' | translate }}</label>
                      <input type="number"
                             class="form-control"
                             [(ngModel)]="element.config.startFrom"
                             (ngModelChange)="updateAutoNumberingElementConfig(selectedItem, i)"
                             min="0" placeholder="1">
                    </div>
                    <div class="input-group">
                      <label class="required-field">{{ 'form.autoNumbering.config.apiKey' | translate }}</label>
                      <input type="text"
                             class="form-control"
                             [(ngModel)]="element.config.apiKey"
                             (ngModelChange)="updateAutoNumberingElementConfig(selectedItem, i)"
                             placeholder="用於取得最新編號的 API Key"
                             required>
                    </div>
                  </div>
                </div>
              </div>

              <button type="button" class="btn btn-sm btn-outline-primary add-element-btn"
                      (click)="addAutoNumberingElement(selectedItem)">
                <i class="fas fa-plus"></i> {{ 'form.autoNumbering.config.addElement' | translate }}
              </button>
            </div>
          </div>

          <!-- 預覽區域 -->
          <div class="property-group">
            <label>{{ 'form.autoNumbering.config.preview' | translate }}</label>
            <div class="preview-display">
              <code>{{ generateAutoNumberingPreview(selectedItem) }}</code>
              <button type="button" class="btn btn-sm btn-outline-secondary"
                      (click)="updateAutoNumberingPreview(selectedItem)">
                <i class="fas fa-sync"></i> 更新預覽
              </button>
            </div>
          </div>
        </div>

        <!-- 影片播放器特殊屬性 -->
        <div class="video-player-properties" *ngIf="selectedItem.type === 'video-player'">
          <div class="property-group">
            <label for="youtube-url">{{ 'form.builder.youtube_url' | translate }}</label>
            <input type="url"
                   id="youtube-url"
                   class="form-control"
                   [(ngModel)]="selectedItem.youtubeUrl"
                   (ngModelChange)="updateSelectedItem()"
                   [placeholder]="'form.builder.youtube_url_placeholder' | translate">>
            <small class="help-text">{{ 'form.builder.youtube_url_help' | translate }}</small>
          </div>

          <div class="property-group">
            <label for="video-title">{{ 'form.builder.video_title' | translate }}</label>
            <input type="text"
                   id="video-title"
                   class="form-control"
                   [(ngModel)]="selectedItem.videoTitle"
                   (ngModelChange)="updateSelectedItem()"
                   [placeholder]="'form.builder.video_title_placeholder' | translate">>
          </div>

          <div class="property-group">
            <label for="video-description">{{ 'form.builder.video_description' | translate }}</label>
            <textarea
                   id="video-description"
                   class="form-control"
                   [(ngModel)]="selectedItem.videoDescription"
                   (ngModelChange)="updateSelectedItem()"
                   [placeholder]="'form.builder.video_description_placeholder' | translate"
                   rows="3"></textarea>
          </div>

          <div class="property-group">
            <label>{{ 'form.builder.size_settings' | translate }}</label>
            <div class="size-controls">
              <div class="size-row">
                <label for="video-width">{{ 'form.builder.width' | translate }}</label>
                <input type="text"
                       id="video-width"
                       class="form-control size-input"
                       [(ngModel)]="selectedItem.videoWidth"
                       (ngModelChange)="updateSelectedItem()"
                       placeholder="100%">
              </div>
              <div class="size-row">
                <label for="video-height">{{ 'form.builder.height' | translate }}</label>
                <input type="text"
                       id="video-height"
                       class="form-control size-input"
                       [(ngModel)]="selectedItem.videoHeight"
                       (ngModelChange)="updateSelectedItem()"
                       placeholder="315px">
              </div>
            </div>
            <small class="help-text">{{ 'form.builder.size_help' | translate }}</small>
          </div>

          <div class="property-group">
            <label>{{ 'form.builder.playback_settings' | translate }}</label>
            <div class="checkbox-group">
              <label class="checkbox-label">
                <input type="checkbox"
                       [(ngModel)]="selectedItem.videoAutoplay"
                       (ngModelChange)="updateSelectedItem()">
                {{ 'form.builder.autoplay' | translate }}
                <small>{{ 'form.builder.autoplay_warning' | translate }}</small>
              </label>

              <label class="checkbox-label">
                <input type="checkbox"
                       [(ngModel)]="selectedItem.videoControls"
                       (ngModelChange)="updateSelectedItem()">
                {{ 'form.builder.show_controls' | translate }}
                <small>{{ 'form.builder.show_controls_description' | translate }}</small>
              </label>

              <label class="checkbox-label">
                <input type="checkbox"
                       [(ngModel)]="selectedItem.videoAllowFullscreen"
                       (ngModelChange)="updateSelectedItem()">
                {{ 'form.builder.allow_fullscreen' | translate }}
                <small>{{ 'form.builder.allow_fullscreen_description' | translate }}</small>
              </label>
            </div>
          </div>
        </div>

        <!-- 檔案上傳管理器特殊屬性 -->
        <div class="property-group" *ngIf="selectedItem.type === 'file-upload-manager'">

          檔案上傳器

          <h5>{{ 'form.builder.file_upload_settings' | translate }}</h5>

          <div class="property-group">
            <label for="max-files">{{ 'form.builder.max_files_allowed' | translate }}</label>
            <!-- <input type="number"
                   id="max-files"
                   class="form-control"
                   [ngModel]="getFileUploadMaxFiles(selectedItem)"
                   (ngModelChange)="setFileUploadMaxFiles($event); updateSelectedItem()"
                   min="1"
                   max="50"
                   placeholder="5"> -->
          </div>

          <div class="property-group">
            <label for="max-file-size">{{ 'form.builder.max_file_size_mb' | translate }}</label>
            <input type="number"
                   id="max-file-size"
                   class="form-control"
                   [ngModel]="getFileUploadMaxSize(selectedItem)"
                   (ngModelChange)="setFileUploadMaxSize($event); updateSelectedItem()"
                   min="1"
                   max="100"
                   placeholder="10">
          </div>

          <div class="property-group">
            <label for="allowed-types">{{ 'form.builder.allowed_file_types' | translate }}</label>
            <input type="text"
                   id="allowed-types"
                   class="form-control"
                   [ngModel]="getFileUploadAllowedTypes(selectedItem)"
                   (ngModelChange)="setFileUploadAllowedTypes($event); updateSelectedItem()"
                   [placeholder]="'form.builder.file_types_placeholder' | translate">
            <small class="help-text">{{ 'form.builder.file_types_help' | translate }}</small>
          </div>

          <div class="property-group">
            <label>
              <input type="checkbox"
                     [ngModel]="getFileUploadDragDrop(selectedItem)"
                     (ngModelChange)="setFileUploadDragDrop($event); updateSelectedItem()">
              {{ 'form.builder.enable_drag_drop' | translate }}
            </label>
          </div>

          <div class="property-group">
            <label>
              <input type="checkbox"
                     [ngModel]="getFileUploadPreview(selectedItem)"
                     (ngModelChange)="setFileUploadPreview($event); updateSelectedItem()">
              {{ 'form.builder.enable_preview' | translate }}
            </label>
          </div>

          <div class="property-group">
            <label>
              <input type="checkbox"
                     [ngModel]="getFileUploadRename(selectedItem)"
                     (ngModelChange)="setFileUploadRename($event); updateSelectedItem()">
              {{ 'form.builder.allow_rename' | translate }}
            </label>
          </div>

          <div class="property-group">
            <label>
              <input type="checkbox"
                     [ngModel]="getFileUploadAllowUserUpload(selectedItem)"
                     (ngModelChange)="setFileUploadAllowUserUpload($event); updateSelectedItem()">
              允許使用者上傳
            </label>
            <small class="help-text">取消勾選時，使用者只能檢視和下載現有檔案，無法上傳新檔案</small>
          </div>
        </div>

        <!-- 指定證件上傳元件特殊屬性 -->
        <div class="property-group" *ngIf="selectedItem.type === 'required-document-upload'">
          <h5>{{ 'form.builder.required_document_settings' | translate }}</h5>

          <div class="property-group">
            <label for="document-name">{{ 'form.builder.document_name' | translate }}</label>
            <input type="text"
                   id="document-name"
                   class="form-control"
                   [ngModel]="getRequiredDocumentName(selectedItem)"
                   (ngModelChange)="setRequiredDocumentName($event); updateSelectedItem()"
                   [placeholder]="'form.builder.document_name_placeholder' | translate">
            <small class="help-text">{{ 'form.builder.document_name_help' | translate }}</small>
          </div>

          <div class="property-group">
            <label for="document-description">{{ 'form.builder.document_description' | translate }}</label>
            <textarea id="document-description"
                      class="form-control"
                      rows="2"
                      [ngModel]="getRequiredDocumentDescription(selectedItem)"
                      (ngModelChange)="setRequiredDocumentDescription($event); updateSelectedItem()"
                      [placeholder]="'form.builder.document_description_placeholder' | translate"></textarea>
            <small class="help-text">{{ 'form.builder.document_description_help' | translate }}</small>
          </div>

          <div class="property-group">
            <label for="expiry-date-field">{{ 'form.builder.expiry_date_field' | translate }}</label>
            <input type="text"
                   id="expiry-date-field"
                   class="form-control"
                   [ngModel]="getRequiredDocumentExpiryField(selectedItem)"
                   (ngModelChange)="setRequiredDocumentExpiryField($event); updateSelectedItem()"
                   [placeholder]="'form.builder.expiry_date_field_placeholder' | translate">
            <small class="help-text">{{ 'form.builder.expiry_date_field_help' | translate }}</small>
          </div>

          <div class="property-group">
            <label for="max-file-size-required">{{ 'form.builder.max_file_size_mb' | translate }}</label>
            <input type="number"
                   id="max-file-size-required"
                   class="form-control"
                   [ngModel]="getRequiredDocumentMaxSize(selectedItem)"
                   (ngModelChange)="setRequiredDocumentMaxSize($event); updateSelectedItem()"
                   min="1"
                   max="100"
                   placeholder="10">
          </div>

          <div class="property-group">
            <label for="allowed-types-required">{{ 'form.builder.allowed_file_types' | translate }}</label>
            <input type="text"
                   id="allowed-types-required"
                   class="form-control"
                   [ngModel]="getRequiredDocumentAllowedTypes(selectedItem)"
                   (ngModelChange)="setRequiredDocumentAllowedTypes($event); updateSelectedItem()"
                   [placeholder]="'form.builder.file_types_placeholder' | translate">
            <small class="help-text">{{ 'form.builder.file_types_help' | translate }}</small>
          </div>

          <div class="property-group">
            <label>
              <input type="checkbox"
                     [ngModel]="getRequiredDocumentAIParsing(selectedItem)"
                     (ngModelChange)="setRequiredDocumentAIParsing($event); updateSelectedItem()">
              {{ 'form.builder.enable_ai_parsing' | translate }}
            </label>
            <small class="help-text">{{ 'form.builder.ai_parsing_help' | translate }}</small>
          </div>

          <div class="property-group">
            <label>
              <input type="checkbox"
                     [ngModel]="getRequiredDocumentDragDrop(selectedItem)"
                     (ngModelChange)="setRequiredDocumentDragDrop($event); updateSelectedItem()">
              {{ 'form.builder.enable_drag_drop' | translate }}
            </label>
          </div>

          <div class="property-group">
            <label>
              <input type="checkbox"
                     [ngModel]="getRequiredDocumentPreview(selectedItem)"
                     (ngModelChange)="setRequiredDocumentPreview($event); updateSelectedItem()">
              {{ 'form.builder.enable_preview' | translate }}
            </label>
          </div>

          <div class="property-group">
            <label>
              <input type="checkbox"
                     [ngModel]="getRequiredDocumentShowFileSize(selectedItem)"
                     (ngModelChange)="setRequiredDocumentShowFileSize($event); updateSelectedItem()">
              {{ 'form.builder.show_file_size' | translate }}
            </label>
          </div>

          <div class="property-group">
            <label>
              <input type="checkbox"
                     [ngModel]="getRequiredDocumentShowUploadTime(selectedItem)"
                     (ngModelChange)="setRequiredDocumentShowUploadTime($event); updateSelectedItem()">
              {{ 'form.builder.show_upload_time' | translate }}
            </label>
          </div>
        </div>

        <!-- 錄音元件特殊屬性 -->
        <div class="property-group" *ngIf="selectedItem.type === 'audio-recorder'">
          <label for="max-duration">{{ 'form.builder.recording_time_limit' | translate }}</label>
          <div class="duration-inputs">
            <div class="input-group">
              <label for="max-duration-input">{{ 'form.builder.max_duration' | translate }}</label>
              <input type="number"
                     id="max-duration-input"
                     class="form-control"
                     [ngModel]="getMaxDuration(selectedItem)"
                     (ngModelChange)="setMaxDuration($event); updateSelectedItem()"
                     min="10"
                     max="3600"
                     placeholder="300">
            </div>
            <div class="input-group">
              <label for="min-duration-input">{{ 'form.builder.min_duration' | translate }}</label>
              <input type="number"
                     id="min-duration-input"
                     class="form-control"
                     [ngModel]="getMinDuration(selectedItem)"
                     (ngModelChange)="setMinDuration($event); updateSelectedItem()"
                     min="1"
                     max="60"
                     placeholder="1">
            </div>
          </div>

          <label for="audio-quality">{{ 'form.builder.audio_quality_setting' | translate }}</label>
          <select
                 id="audio-quality"
                 class="form-control"
                 [ngModel]="getAudioQuality(selectedItem)"
                 (ngModelChange)="setAudioQuality($event); updateSelectedItem()">
            <option value="low">{{ 'form.builder.low_quality' | translate }}</option>
            <option value="medium">{{ 'form.builder.medium_quality' | translate }}</option>
            <option value="high">{{ 'form.builder.high_quality' | translate }}</option>
          </select>

          <label for="audio-format">{{ 'form.builder.audio_format' | translate }}</label>
          <select
                 id="audio-format"
                 class="form-control"
                 [ngModel]="getAudioFormat(selectedItem)"
                 (ngModelChange)="setAudioFormat($event); updateSelectedItem()">
            <option value="wav">WAV</option>
            <option value="mp3">MP3</option>
          </select>
        </div>

        <!-- 多人簽名元件特殊屬性 -->
        <div class="property-group" *ngIf="selectedItem.type === 'meeting-signature-collection'">
          <label for="signature-title">{{ 'form.builder.signature_title' | translate }}</label>
          <input type="text"
                 id="signature-title"
                 class="form-control"
                 [ngModel]="getSignatureTitle(selectedItem)"
                 (ngModelChange)="setSignatureTitle($event); updateSelectedItem()"
                 [placeholder]="'form.builder.enter_signature_title' | translate">

          <label for="document-id">{{ 'form.builder.document_id' | translate }}</label>
          <input type="text"
                 id="document-id"
                 class="form-control"
                 [ngModel]="getDocumentId(selectedItem)"
                 (ngModelChange)="setDocumentId($event); updateSelectedItem()"
                 [placeholder]="'form.builder.enter_document_id' | translate">
        </div>

        <!-- 驗證規則（未來擴展） -->
        <div class="property-group">
          <label>
            <input type="checkbox"
                   [(ngModel)]="selectedItem.required"
                   (ngModelChange)="updateSelectedItem()">
            {{ 'form.builder.required_field' | translate }}
          </label>
        </div>
      </div>

      <ng-template #noSelection>
        <div class="no-selection">
          <div class="no-selection-icon">
            <i class="fas fa-hand-pointer"></i>
          </div>
          <p>{{ 'form.builder.click_to_edit_properties' | translate }}</p>
        </div>
      </ng-template>
    </div>
  </div>

  <!-- 階段編輯器彈窗 -->
  <app-stage-editor
    [visible]="showStageEditor"
    [editingStage]="editingStage"
    (close)="closeStageEditor()"
    (save)="saveStage($event)">
  </app-stage-editor>
</div>
